import { defineStore } from 'pinia'
import { checkUserIPVeryfiStatus } from '@ms/api/user'

export const useCloudflareStore = defineStore('cloudflare', {
  state: () => ({
    // 是否验证过 ip
    checked: false,
    // 后台验证是否需要 cloudflare 验证
    needCheck: false,
    // cloudflare 验证弹窗
    cfVisible: false,
    cfToken: '',
    verifyToken: '',
    widgetId: ''
  }),
  actions: {
    setCfToken(token = '') {
      this.cfToken = token
      this.cfVisible = false
    },
    resetCfToken() {
      if (!this.cfToken) return
      this.cfToken = ''
      this.widgetId && window.turnstile?.reset(this.widgetId)
    },
    setVerifyToken(token = '') {
      this.verifyToken = token
    },
    setWidgetId(id = '') {
      this.widgetId = id
    },
    toggleCloudflareVerify(bool = false) {
      this.cfVisible = bool
      if (bool && this.cfToken) {
        this.cfToken = ''
        this.verifyToken = ''
        this.widgetId && window.turnstile?.reset(this.widgetId)
      }
    },
    async getCloudflareVerifyStatus(phone) {
      const { error, data } = await checkUserIPVeryfiStatus(phone)
      if (error) {
        this.needCheck = false
      } else {
        this.checked = true
        this.needCheck = data?.needCheck
      }
    }
  }
})

/**
 * Checks the Cloudflare verification status and initiates verification if needed.
 *
 * This function performs the following steps:
 * 1. Retrieves the Cloudflare store instance.
 * 2. If the status hasn't been checked, it fetches the current verification status.
 * 3. If verification is needed and no token is present, it toggles the verification flag.
 *
 * @async
 * @function checkCloudflareVerification
 * @returns {Promise<boolean>} A promise that resolves to:
 *   - true if verification is not needed or already completed
 *   - false if verification is required and has been initiated
 */
export const checkCloudflareVerification = async (phone) => {
  const cfStore = useCloudflareStore()
  if (!cfStore.checked) {
    await cfStore.getCloudflareVerifyStatus(phone)
  }
  if (cfStore.needCheck && !cfStore.cfToken) {
    cfStore.toggleCloudflareVerify(true)
    return false
  }
  return true
}
